var _path, _line, _line2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6835 4.33333H0.82181C0.603853 4.33333 0.394822 4.42464 0.240703 4.58717C0.0865833 4.74971 0 4.97015 0 5.2V12.1333C0 12.3632 0.0865833 12.5836 0.240703 12.7462C0.394822 12.9087 0.603853 13 0.82181 13H10.6835C10.9015 13 11.1105 12.9087 11.2646 12.7462C11.4188 12.5836 11.5053 12.3632 11.5053 12.1333V5.2C11.5053 4.97015 11.4188 4.74971 11.2646 4.58717C11.1105 4.42464 10.9015 4.33333 10.6835 4.33333V4.33333ZM9.77954 5.2L5.75267 8.138L1.7258 5.2H9.77954ZM0.82181 12.1333V5.59433L5.51846 9.022C5.58724 9.07232 5.66896 9.09929 5.75267 9.09929C5.83639 9.09929 5.91811 9.07232 5.98689 9.022L10.6835 5.59433V12.1333H0.82181Z",
    fill: "black"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 14.0558,
    y1: 0.39,
    x2: 14.0558,
    y2: 4.19824,
    stroke: "black",
    strokeWidth: 0.78,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 11.9456,
    y1: 2.08764,
    x2: 15.7538,
    y2: 2.08764,
    stroke: "black",
    strokeWidth: 0.78,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvite);
export default __webpack_public_path__ + "static/media/invite.4d07c5ec4253806d33f83b2ed1cb7667.svg";
export { ForwardRef as ReactComponent };